var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H0.5V22H27.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2006_222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H0.5V22H27.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2006_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.73186C0.5 3.58101 0.957173 2.4773 1.77095 1.66353C2.58472 0.849751 3.68844 0.392578 4.83929 0.392578H23.1607C24.3116 0.392578 25.4153 0.849751 26.2291 1.66353C27.0428 2.4773 27.5 3.58101 27.5 4.73186V17.2676C27.5 18.4184 27.0428 19.5221 26.2291 20.3359C25.4153 21.1497 24.3116 21.6069 23.1607 21.6069H4.83929C3.68844 21.6069 2.58472 21.1497 1.77095 20.3359C0.957173 19.5221 0.5 18.4184 0.5 17.2676V4.73186ZM4.83929 2.32115C4.19992 2.32115 3.58675 2.57513 3.13465 3.02723C2.68256 3.47933 2.42857 4.0925 2.42857 4.73186V6.17829H25.5714V4.73186C25.5714 4.0925 25.3174 3.47933 24.8653 3.02723C24.4132 2.57513 23.8001 2.32115 23.1607 2.32115H4.83929ZM2.42857 17.2676C2.42857 17.9069 2.68256 18.5201 3.13465 18.9722C3.58675 19.4243 4.19992 19.6783 4.83929 19.6783H23.1607C23.8001 19.6783 24.4132 19.4243 24.8653 18.9722C25.3174 18.5201 25.5714 17.9069 25.5714 17.2676V8.10686H2.42857V17.2676ZM18.8214 13.8926H21.7143C21.97 13.8926 22.2153 13.9942 22.3961 14.175C22.577 14.3558 22.6786 14.6011 22.6786 14.8569C22.6786 15.1126 22.577 15.3579 22.3961 15.5387C22.2153 15.7196 21.97 15.8211 21.7143 15.8211H18.8214C18.5657 15.8211 18.3204 15.7196 18.1396 15.5387C17.9587 15.3579 17.8571 15.1126 17.8571 14.8569C17.8571 14.6011 17.9587 14.3558 18.1396 14.175C18.3204 13.9942 18.5657 13.8926 18.8214 13.8926Z",
    fill: "#185A7D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.68c890b0e5674989401641e17299f479.svg";
export { ForwardRef as ReactComponent };